"use strict";
/**
 * return the indices of a given array in an order that matches the decreasing order of the array values
 * @param x : array to argsort
 * @returns sorted list of indices in the decreasing order
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mean = exports.addArrays = exports.get_objectiveID_of_activity = exports.get_act_id = exports.getObjective = exports.argsortDesc = void 0;
let argsortDesc = (x) => {
    var len = x.length;
    var indices = new Array(len);
    for (var i = 0; i < len; i++) {
        indices[i] = i;
        indices.sort((a, b) => { return x[a] > x[b] ? -1 : x[a] < x[b] ? 1 : 0; });
    }
    return indices;
};
exports.argsortDesc = argsortDesc;
let getObjective = (params, exId) => {
    const ModuleData = params["graph"]["graph"];
    const idModule = params["graph"]["main_act"];
    const objectives = ModuleData[idModule]["subgroups"][0];
    const ontology = params["graph"]["exercises_ontology"];
    for (let i = 0; i < ontology.length; i++) {
        const actId = ontology[i]["id"];
        for (let j = 0; j < objectives.length; j++) {
            let obj = objectives[j];
            for (let act of ModuleData[obj]["subgroups"][0]) {
                if (actId == act) {
                    for (let exoId of ontology[i]["exerciseIds"]) {
                        if (exId == exoId) {
                            return obj;
                        }
                    }
                }
            }
        }
    }
};
exports.getObjective = getObjective;
function get_act_id(exercises_ontology, idEx) {
    let keys = Object.keys(exercises_ontology);
    for (let i of keys) {
        for (let j = 0; j < exercises_ontology[i].length; j++) {
            if (exercises_ontology[i][j] == idEx) {
                return i;
            }
        }
    }
    throw new Error("exercise not in ontology");
}
exports.get_act_id = get_act_id;
function get_objectiveID_of_activity(actID, activities) {
    let keys = Object.keys(activities);
    for (let i of keys) {
        for (let j = 0; j < activities[i].length; j++) {
            if (activities[i][j] == actID) {
                return i;
            }
        }
    }
    throw new Error("activity has no objective realted in ontology");
}
exports.get_objectiveID_of_activity = get_objectiveID_of_activity;
/**
     * method which estimates the theta parameter for the student according to the history of his answers
     * @returns estimation of theta parameter for the student
     */
function addArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        throw new Error("Cannot add arrays of different lengths");
    }
    return new Float32Array(arr1.map((n, i) => n + arr2[i]));
}
exports.addArrays = addArrays;
function mean(array) {
    if (array.length == 0) {
        return 0;
    }
    let mean = 0;
    for (let i of array) {
        mean += i;
    }
    mean = 1.0 * mean / array.length;
    return mean;
}
exports.mean = mean;
